// extracted by mini-css-extract-plugin
export default {"wrapper":"AIModelsLogo_wrapper__sqV7z"};